{
    "proxy": {
        "actions": {
            "copy": "Copy proxy",
            "delete": "Delete proxy",
            "import": "Import proxies",
            "restore": "Restore proxy",
            "speedtest": "Speedtest"
        },
        "import": {
            "added": "Proxy was added",
            "placeholder": "Format: 'name, type, ip, port, login, password'. Ex. 'Italy, HTTP, 172.0.0.1, 2222, username, pass'",
            "resultTitle": "Result",
            "title": "Import Proxies (Format: \"name, type, ip, port, login, password\". Ex. \"Italy, HTTP, 172.0.0.1, 2222, username, pass\")",
            "upload": "Upload"
        },
        "importIncorectFormat": "Incorrect format (name, type, ip, port, login, password)",
        "importWrongProxyPort": "Wrong proxy port. Should be number",
        "importWrongProxyType": "Wrong proxy type. Should be HTTP, SOCKS5 or IP",
        "confirmDelete": "Delete this proxy?",
        "confirmRestore": "Restore this proxy?",
        "dataError": "Error",
        "speedtest": {
            "directLine": "Direct Time: {connect}sec, Total Time: {total}sec",
            "failed": "Failed",
            "proxyLine": "Connect Time: {connect}sec, Total Time: {total}sec",
            "realIp": "Real IP: {ip}",
            "realIpUnknown": "Unknown",
            "runTest": "Run Test",
            "title": "Speed Test Proxy. Select Sites"
        },
        "bulk": {
            "apply": "Set",
            "confirmDelete": "Delete {count} selected proxy(ies)?",
            "confirmSetBookmakers": "Set bookmakers for {count} selected proxy(ies)?",
            "delete": "Delete",
            "setBookmakers": "Set bookmakers"
        },
        "form": {
            "country": "Country",
            "countryPlaceholder": "Not selected",
            "createTitle": "Add proxy",
            "editTitle": "Edit proxy",
            "ip": "Ip / Hostname",
            "isActive": "Active",
            "isAgent": "Agent",
            "login": "Login",
            "name": "Name",
            "password": "Password",
            "port": "Port",
            "save": "Save",
            "sites": "Bookmakers",
            "sitesPlaceholder": "Not selected",
            "type": "Type"
        },
        "columns": {
            "abnCount": "#ABN",
            "abnPerc": "ABN%",
            "accountCount": "A/C",
            "betCount": "#Bets",
            "bookmakers": "Bookmakers",
            "connectTime": "Connect time",
            "hostname": "Hostname",
            "isActive": "Active",
            "isAgent": "Agent",
            "lastCheck": "Last check",
            "login": "Login",
            "name": "Name",
            "totalTime": "Total time",
            "type": "Type"
        },
        "filters": {
            "proxyAvailable": "Availability",
            "proxyAvailableAvailable": "Available",
            "proxyAvailableDeleted": "Deleted",
            "proxyBookmakerId": "Bookmakers",
            "proxySearch": "Search",
            "proxyStatus": "Status",
            "proxyStatusActive": "Active",
            "proxyStatusInactive": "Inactive"
        }
    },
    "accounts": {
        "actions": {
            "copy": "Copy to new account",
            "delete": "Delete account",
            "relogin": "Relogin account"
        },
        "bulk": {
            "active": "Active",
            "confirmActive": "Set {count} selected account(s) to active?",
            "confirmDelete": "Delete {count} selected account(s)?",
            "confirmDisable": "Disable {count} selected account(s)?",
            "confirmInactive": "Set {count} selected account(s) to inactive?",
            "confirmRelogin": "Relogin {count} selected account(s)?",
            "delete": "Delete",
            "disable": "Disable",
            "inactive": "Inactive",
            "relogin": "Relogin"
        },
        "columns": {
            "active": "Active",
            "bets": "Bets",
            "botAbbr": "B",
            "browser": "Browser",
            "credit": "Credit",
            "currency": "C",
            "date": "Date",
            "disabled": "Disabled",
            "login": "Login",
            "orderAbbr": "O",
            "parse": "Parse",
            "proxy": "Proxy",
            "set": "Set",
            "sinceLastBet": "Since last bet",
            "status": "Status",
            "user": "User",
            "validPerc": "Vld%"
        },
        "confirmDelete": "Delete this account?",
        "confirmRelogin": "Relogin this account?",
        "params": {
            "columns": {
                "param": "Param",
                "value": "Value"
            },
            "alreadyExists": "Param with this name already exists for this account.",
            "paramRequired": "Param is required.",
            "paramMaxLength": "Param may not be greater than {max} characters.",
            "valueRequired": "Value is required.",
            "valueMaxLength": "Value may not be greater than {max} characters.",
            "confirmDelete": "Delete this param?",
            "editHint": "Double-click to edit",
            "editHintMobile": "Tap to edit",
            "filters": {
                "accountId": "Account"
            },
            "form": {
                "createTitle": "New param"
            },
            "loadError": "Unable to load params.",
            "noData": "No params."
        },
        "deleted": "Account deleted.",
        "filters": {
            "accountBookmakerId": "Bookmaker",
            "accountSearch": "Search",
            "accountStatus": "Status",
            "accountStatusActive": "Active",
            "accountStatusAll": "All Accounts",
            "accountStatusDeleted": "Deleted",
            "accountToolUserId": "Player"
        },
        "form": {
            "addPlayer": "Add player",
            "apiKey": "API key",
            "browser": "Browser",
            "commissionBot": "Bot commission",
            "commissionOrder": "Order commission",
            "createTitle": "New account",
            "created": "Account created.",
            "currency": "Currency",
            "currencyPlaceholder": "Select currency",
            "editTitle": "Edit account",
            "emulate": "Emulate",
            "isActive": "Active",
            "isDisable": "Disabled",
            "login": "Login",
            "loginPredefined": "New login",
            "name": "Name",
            "password": "Password",
            "platformBot": "Bot",
            "platformOrder": "Order",
            "positionPerc": "Position %",
            "proxy": "Proxy",
            "proxyPlaceholder": "Not used",
            "proxyPool": "Proxy pool",
            "proxyPoolPlaceholder": "No proxies selected",
            "save": "Save",
            "saved": "Account updated.",
            "stateDisabled": "Disabled",
            "stateEnabled": "Enabled",
            "toolUsers": "Tool users",
            "usedForParser": "Use for parse",
            "userSearchPlaceholder": "Search player (min. 3 characters)",
            "validPerc": "Valid %"
        },
        "id": "ID",
        "login": "Login",
        "name": "Name",
        "stats": {
            "accounts": "Accounts",
            "disabled": "Disabled",
            "loggedIn": "Logged in",
            "loggedOut": "Logged out",
            "loggingIn": "Logging in"
        }
    },
    "action": {
        "add": "Add",
        "apply": "Apply",
        "cancel": "Cancel",
        "cancelOrder": "Cancel Order",
        "close": "Close",
        "closeWindow": "Close Window",
        "confirm": "Confirm",
        "copy": "Copy",
        "delete": "Delete",
        "deleteText": "Are you sure you want to delete this item?",
        "edit": "Edit",
        "export": "Export",
        "newOrder": "New Order",
        "no": "No",
        "ok": "OK",
        "refresh": "Refresh",
        "reload": "Reload",
        "reset": "Reset",
        "save": "SAVE",
        "updated": "Last Edit",
        "yes": "Yes"
    },
    "pwa": {
        "newVersionAvailable": "New version available"
    },
    "alerts": {
        "account": "Account",
        "alert": "Alert",
        "alertDateFilter": "Alert date",
        "alertType": "Alert Type",
        "allAlerts": "All Alerts",
        "book": "Book",
        "date": "Date",
        "dismiss": "Dismiss",
        "dm": "DM",
        "dmTooltip": "Dismissed",
        "errorMessage": "Error message",
        "game": "GAME",
        "user": "User"
    },
    "transfer": {
        "approvedByFilter": "Approved by",
        "confirmDelete": "Delete this transfer?",
        "currencyFilter": "All currencies",
        "delete": "Delete",
        "form": {
            "amount": "Amount ({symbol})",
            "createTitle": "Add transfer",
            "description": "Description",
            "editTitle": "Edit transfer",
            "method": "Method",
            "operation": "Operation",
            "save": "Save",
            "status": "Status",
            "user": "User"
        },
        "methodFilter": "Method",
        "operationFilter": "Operation",
        "statusFilter": "Status",
        "title": "Deposits & Withdrawals",
        "userFilter": "User",
        "withdrawLimit": "You cannot withdraw more than the balance available",
        "columns": {
            "agent": "Agent",
            "amount": "Amount",
            "approvedBy": "Approved by",
            "currency": "Currency",
            "date": "Date",
            "method": "Method",
            "operation": "Operation",
            "status": "Status",
            "user": "User"
        }
    },
    "notifications": {
        "all": "All",
        "confirmDelete": "Delete this notification?",
        "countryFilter": "All countries",
        "createdByFilter": "Created by",
        "dateFilter": "Date",
        "delete": "Delete",
        "form": {
            "active": "Active",
            "allCountries": "All countries",
            "allPlatforms": "All platforms",
            "allRecipients": "All recipients",
            "country": "Country",
            "createTitle": "Add notification",
            "editTitle": "Edit notification",
            "platform": "Platform",
            "recipients": "Recipients",
            "save": "Save",
            "textEn": "EN",
            "textPt": "PT",
            "type": "Type"
        },
        "idFilter": "Notification ID",
        "platformFilter": "All platforms",
        "recipientFilter": "Player",
        "title": "Notifications",
        "typeFilter": "All notifications",
        "types": {
            "error": "Error",
            "info": "Info",
            "message": "Message",
            "warning": "Warning"
        },
        "columns": {
            "active": "Active",
            "countries": "Countries",
            "createdBy": "Created by",
            "date": "Date",
            "dismiss": "Dismiss",
            "platform": "Platform",
            "recipients": "Recipients",
            "textEn": "Notification EN",
            "textPt": "Notification PT",
            "type": "Type"
        }
    },
    "currencyExchange": {
        "columns": {
            "date": "Date",
            "eurToCny": "EUR to CNY",
            "eurToUsd": "EUR to USD",
            "eurToGbp": "EUR to GBP",
            "eurToBrl": "EUR to BRL",
            "eurToHkd": "EUR to HKD",
            "eurToMyr": "EUR to MYR",
            "gbpToBrl": "GBP to BRL",
            "cnyToUsd": "CNY to USD",
            "cnyToBrl": "CNY to BRL",
            "cnyToMyr": "CNY to MYR",
            "cnyToHkd": "CNY to HKD",
            "usdToBrl": "USD to BRL",
            "usdToGbp": "USD to GBP",
            "usdToHkd": "USD to HKD",
            "usdToMyr": "USD to MYR",
            "hkdToBrl": "HKD to BRL",
            "hkdToMyr": "HKD to MYR",
            "myrToBrl": "MYR to BRL"
        },
        "form": {
            "createTitle": "Edit Exchange Rates",
            "save": "Save",
            "eurToCny": "EUR to CNY rate",
            "eurToUsd": "EUR to USD rate",
            "eurToGbp": "EUR to GBP rate",
            "eurToBrl": "EUR to BRL rate",
            "eurToHkd": "EUR to HKD rate",
            "eurToMyr": "EUR to MYR rate",
            "gbpToBrl": "GBP to BRL rate",
            "cnyToUsd": "CNY to USD rate",
            "cnyToBrl": "CNY to BRL rate",
            "cnyToMyr": "CNY to MYR rate",
            "cnyToHkd": "CNY to HKD rate",
            "usdToBrl": "USD to BRL rate",
            "usdToGbp": "USD to GBP rate",
            "usdToHkd": "USD to HKD rate",
            "usdToMyr": "USD to MYR rate",
            "hkdToBrl": "HKD to BRL rate",
            "hkdToMyr": "HKD to MYR rate",
            "myrToBrl": "MYR to BRL rate"
        }
    },
    "appAlerts": {
        "alertCode": "Alert Code",
        "alertData": "Alert Data",
        "alertDateFilter": "Alert date",
        "alertType": "All Alerts",
        "check": "Check",
        "checkTooltip": "Investigate",
        "code": "Code",
        "comment": "Comment",
        "confirmDelete": "Are you sure you want to delete selected alerts?",
        "confirmDismiss": "Are you sure you want to dismiss selected alerts?",
        "count": "#",
        "dataLoadError": "Failed to load alert data",
        "date": "Date",
        "delete": "Delete",
        "dism": "DISM",
        "dismTooltip": "Dismissed",
        "dismiss": "Dismiss",
        "dismissed": "Not Dismissed",
        "dismissedOption": "Dismissed",
        "investigate": "All",
        "more": "More",
        "notDismissed": "Not Dismissed",
        "notInvestigate": "Not investigate",
        "priority": "All Priority",
        "priorityCritical": "Critical",
        "priorityHigh": "High",
        "priorityLow": "Low",
        "text": "Text",
        "typeInfo": "Info",
        "typeProblem": "Problem",
        "typeSingle": "Single",
        "user": "User"
    },
    "bets": {
        "NC": "N/C",
        "account": "Account",
        "actions": "Actions",
        "activityType": {
            "allBets": "All Bets",
            "betsDone": "Bets executed",
            "betsFailed": "Bets missed",
            "title": "Activity Type"
        },
        "agent": "Agent",
        "agentBalance": "AG Bal",
        "agentPt": "AG PT",
        "agentStake": "AG Stake",
        "agentTotal": "Agent Total",
        "allBetTypes": "All Bet Types",
        "allBookmakers": "All Bookmakers",
        "allPlatforms": "All Platforms",
        "allStatus": "All Status",
        "balance": "Balance",
        "bet": "Bet",
        "betDateFilter": "Bet date",
        "betDateType": "Date Type",
        "betId": "Bet ID",
        "betSearch": "Bet Search",
        "betType": "Bet Type",
        "export": "Bet Export",
        "betVsClose": "Bet vs Close",
        "betVsOpen": "Bet vs Open",
        "bets": "Bets",
        "betsWithMissingStake": "Bets with missing stake",
        "betHasPositionPlatformRule": "Bets with platform rule",
        "betHasPositionUserRule": "Bets with user rules",
        "book": "Book",
        "bookBalance": "Book Bal",
        "bookStake": "B Stake",
        "bookmaker": "All Bookmakers",
        "bot": "Bot",
        "botOrder": "Bot / Order",
        "closeOdds": "Close Odds",
        "coOdds": "CO Odds",
        "commission": "Comm",
        "companyBalance": "CO Bal",
        "companyPl": "CO P/L",
        "cornersNotConfirmed": "Corners not confirmed",
        "customer": "Customer",
        "customerBalance": "Customer Bal",
        "date": "Date",
        "editBet": {
            "betResult": "Bet Result",
            "betStatus": "Bet Status",
            "bookmaker": "Bookmaker",
            "errors": {
                "invalidStatusChange": "New bet status is not valid",
                "resultRequired": "Bet result is required when status is Settled"
            },
            "player": "Player",
            "title": "Set Status/Balance"
        },
        "error": {
            "checkBets": "Something went wrong, check bets"
        },
        "errorName": "Error Name",
        "ftScore": "FT Score",
        "game": "Game",
        "info": {
            "fields": {
                "account": "Account",
                "accountValid": "Account Valid",
                "activatedAt": "Activated At",
                "age": "Age",
                "agent": "Agent",
                "agentPosition": "Agent Position",
                "agentPositionRequired": "Agent Position Required",
                "attackSupremacy": "Attack supremacy",
                "attacks": "Attacks",
                "awayTeam": "Away Team",
                "balance": "Balance",
                "bet": "Bet",
                "betAtHalfTime": "Bet at Half Time",
                "betDate": "Bet Date",
                "betId": "Bet ID",
                "betRepetition": "Bet repetition",
                "betSelection": "Bet selection",
                "betType": "Bet Type",
                "betVsClose": "Bet vs Close",
                "betVsOpen": "Bet vs Open",
                "bookmaker": "Bookmaker",
                "bookmakerBalance": "Bookmaker Balance",
                "bookmakerBetId": "Bookmaker Bet ID",
                "bookmakerOdds": "Bookmaker Odds",
                "bookmakerStakeReal": "Bookmaker Stake (real)",
                "bookmakerStakeValid": "Bookmaker Stake (valid)",
                "botId": "Bot ID",
                "botName": "Name",
                "botStake": "Bot Stake",
                "category": "Category",
                "closeOdds": "Close Odds",
                "closingGoalLine": "Closing goal line",
                "closingHandicap": "Closing handicap",
                "companyPl": "Company P/L",
                "companyPositionBalance": "Company Position Balance",
                "corners": "Corners",
                "cornersFt": "Corners FT",
                "cornersHt": "Corners HT",
                "cornersSupremacy": "Corners supremacy",
                "dangerousAttackSupremacy": "Dangerous attack supremacy",
                "dangerousAttacks": "Dangerous Attacks",
                "date": "Date",
                "description": "Description",
                "deviceType": "Device Type",
                "eventDate": "Event Date",
                "exchange": "Exchange",
                "exchangeRate": "Exchange Rate",
                "excludedLeagues": "Excluded Leagues",
                "includedLeagues": "Included Leagues",
                "extraFee": "Extra Fee",
                "favoriteUnderdog": "Favorite/Underdog",
                "gender": "Gender",
                "goalHandicap": "Goal handicap",
                "goalLine": "Goal Line",
                "grossBookmaker": "Gross (Bookmaker)",
                "handicap": "Handicap",
                "homeTeam": "Home Team",
                "jollyWinPerc": "Jolly Win %",
                "jollywhere": "Jollywhere",
                "league": "League | Leagues",
                "limitsCategory": "Limits category",
                "market": "Market",
                "marketMargin": "Market Margin",
                "marketType": "Market Type",
                "maxStakeValid": "Max Stake (valid)",
                "minute": "Minute",
                "missingStake": "Missing Stake",
                "odds": "Odds",
                "openOdds": "Open Odds",
                "openingGoalLine": "Opening goal line",
                "openingHandicap": "Opening handicap",
                "order": "Order",
                "orderStake": "Order Stake",
                "period": "Period",
                "playerStake": "Player Stake",
                "position": "Position",
                "positionRequired": "Position Required",
                "positionPlatformRule": "Position Platform Rule",
                "positionUserRule": "Position User Rule",
                "possession": "Possession %",
                "redCard": "Red Card",
                "redCards": "Red Cards",
                "result": "Result",
                "score": "Score",
                "scoreFt": "Score FT",
                "scoreHt": "Score HT",
                "scoreSum": "Score Sum",
                "shots": "Shots",
                "shotsOnTargetSupremacy": "Shots on target supremacy",
                "shotsSupremacy": "Shots supremacy",
                "situation": "Situation",
                "skipBetfairOnly": "Skip Betfair Only",
                "stake": "Stake",
                "status": "Status",
                "topUps": "Top UPS",
                "totalAttack": "Total attack",
                "totalCorners": "Total corners",
                "totalDangerousAttack": "Total dangerous attack",
                "totalShots": "Total shots",
                "totalShotsOnTarget": "Total shots on target",
                "updatedAt": "Updated At",
                "useMinStake": "Use Min Stake",
                "user": "User",
                "wlBetId": "WL Bet ID"
            },
            "sections": {
                "balance": "Balance",
                "betInformation": "Bet Information",
                "botConditions": "Bot conditions",
                "commission": "Commission",
                "history": "History",
                "liveStats": "Live Stats"
            },
            "subsections": {
                "competition": "Competition",
                "liveConditions": "Live Conditions",
                "liveStatsConditions": "Live Stats Conditions",
                "marketMarginConditions": "Market Margin Conditions",
                "pregameConditions": "Pregame Conditions"
            },
            "title": "Bet Details"
        },
        "league": "League",
        "log": {
            "error": "Failed to load bet log",
            "showFormatted": "Show initial view",
            "showJson": "Show JSON view",
            "title": "Bet Log"
        },
        "market": "Market",
        "marketType": "MT",
        "message": "Message",
        "missingStake": "M Stake",
        "odds": "Odds",
        "openBets": "Open bets",
        "openOdds": "Open Odds",
        "orderId": "Order ID",
        "payCommission": "Pay Comm",
        "period": "M",
        "periodType": "Period Type",
        "periodTypeShort": "PT",
        "plOdds": "PL Odds",
        "placementGmt": "Placement GMT",
        "placementLondon": "Placement London",
        "platform": "Platform",
        "player": "Player",
        "playerBalance": "PL Bal",
        "position": "Position",
        "pt": "PT",
        "ref": "Ref",
        "refund": {
            "confirm": "Refund",
            "message": "Are you sure you want to refund this bet?",
            "messagePlural": "Are you sure you want to refund this bets?",
            "title": "Refund bet"
        },
        "result": "Result",
        "resultUsingScore": {
            "infoAuto": "Each bet will be settled using its own final score.",
            "infoManual": "Score \"{score}\" will be applied to all {total} selected bet(s).",
            "infoSkipped": "{count} bet(s) have no final score and will be skipped. Result will be set for {applied} of {total}.",
            "invalidFormat": "Invalid score format. Example: 2-1 (max 999-999)",
            "mismatchWarning": "Entered score differs from the event score for {count} of {total} bet(s).",
            "noScore": "There is no final score, unable to set the result.",
            "note": "Note: the bet result will be reset for the bookmaker and the player.",
            "placementError": "Final score can't be lower than the score at the moment the bet was placed. Fix the score to continue.",
            "scoreLabel": "Final score",
            "title": "Set bet result using score"
        },
        "score": "Score",
        "scoreNotConfirmed": "Score not confirmed",
        "setResult": {
            "message": "Are you sure you want to set result \"{result}\" for selected bet?",
            "messagePlural": "Are you sure you want to set result \"{result}\" for selected bets?",
            "setHL": "Set \"HL\" result",
            "setHW": "Set \"HW\" result",
            "setL": "Set \"L\" result",
            "setP": "Set \"P\" result",
            "setW": "Set \"W\" result",
            "statusMessage": "Are you sure you want to set new status/result for selected bet?",
            "unset": "Unset bet result",
            "unsetMessage": "Are you sure you want to unset result for selected bet?",
            "unsetMessagePlural": "Are you sure you want to unset result for selected bets?"
        },
        "settlementGmt": "Settlement GMT",
        "settlementLondon": "Settlement London",
        "skipAutomaticSettlement": {
            "message": "Are you sure you want to skip automatic settlement for selected bet?",
            "messagePlural": "Are you sure you want to skip automatic settlement for selected bets?",
            "title": "Skip automatic settlement"
        },
        "stake": "Stake",
        "status": "Status",
        "statusWarning": {
            "manuallySetBookmaker": "Bookmaker result set manually",
            "manuallySetPlayer": "Player result set manually"
        },
        "title": "Bets",
        "toolUserObserve": {
            "excludeIrregular": "Exclude Irregular",
            "irregular": "Irregular Users",
            "watched": "Watched Users"
        },
        "tooltips": {
            "agentBalanceTooltip": "Agent Balance",
            "agentPtTooltip": "Agent position",
            "agentStakeTooltip": "Agent Stake",
            "agentTotalTooltip": "Agent Total",
            "betInfoTooltip": "Bet Details",
            "betLogTooltip": "View Bet Log",
            "betVsCloseTooltip": "PL Odds minus Close Odds",
            "betVsOpenTooltip": "PL Odds minus Open Odds",
            "bookBalanceTooltip": "Bookmaker Balance",
            "bookStakeTooltip": "Bookmaker Stake",
            "bookTooltip": "Bookmaker",
            "closeOddsTooltip": "Close Odds",
            "coOddsTooltip": "Company Odds",
            "commissionTooltip": "Gross Commission",
            "companyBalanceTooltip": "Company Balance",
            "companyPlTooltip": "Company Profit/Loss",
            "customerBalanceTooltip": "Customer Balance",
            "marketTypeTooltip": "Market Type",
            "missingStakeTooltip": "Missing Stake",
            "openOddsTooltip": "Open Odds",
            "payCommissionTooltip": "Payable Commission",
            "periodTooltip": "Period of the event(FT/1H)",
            "plOddsTooltip": "Player Odds",
            "playerBalanceTooltip": "Player Balance",
            "ptTooltip": "Company position",
            "refundTooltip": "Refund Bet",
            "scoreTooltip": "Score",
            "stakeTooltip": "Player Stake",
            "topupTooltip": "Top up",
            "viewWlTransactions": "View WL Transactions",
            "viewBetSettlement": "View Bet Settlement"
        },
        "topup": "Tup",
        "tradingType": "Trading Type",
        "user": "User",
        "userObserveId": "All Users",
        "void": {
            "confirm": "Void",
            "message": "Are you sure you want to void this bet?",
            "messagePlural": "Are you sure you want to void these bets?",
            "title": "Void bet"
        }
    },
    "bookBalance": {
        "agBalance": "AG Balance",
        "agTurnover": "AG Turnover",
        "betCount": "#Bets",
        "betDateFilter": "Bet date",
        "bookBalance": "Book Balance",
        "bookComm": "Book Comm",
        "bookFees": "Book Fees",
        "bookStaked": "Book Staked",
        "bookTotal": "Book Total",
        "bookTurnover": "Book Turnover",
        "bookmaker": "Bookmaker",
        "brlPlayersAccounts": "Brazilian Real(R$) Players Accounts",
        "coPositionBalance": "CO Position Balance",
        "companyPL": "Company P/L",
        "datePeriod": {
            "currentMonth": "Current Month",
            "currentWeek": "Current Week",
            "currentYear": "Current Year",
            "lastMonth": "Last Month",
            "lastWeek": "Last Week",
            "range": "Range Date",
            "title": "Range Date",
            "today": "Today",
            "yesterday": "Yesterday"
        },
        "euroPlayersAccounts": "Euro(€) Players Accounts",
        "feesRebate": "Fees Rebate",
        "gbpPlayersAccounts": "GBP(£) Players Accounts",
        "payComms": "Pay Comms",
        "playerBalance": "Player Balance",
        "playerYield": "Player Yield",
        "position": "Position",
        "staked": "Staked",
        "totalEuro": "TOTAL Euro(€)",
        "turnover": "Turnover",
        "usdPlayersAccounts": "USD($) Players Accounts"
    },
    "userBalance": {
        "agPayComms": "AG Pay Comms",
        "agTotal": "AG Total",
        "balance": "Balance",
        "bookRebate": "Book Rebate",
        "bots": "#Bots",
        "comms": "Comms",
        "company": "Company",
        "pl": "P/L",
        "ptBalance": "PT Balance",
        "role": "Role",
        "user": "User"
    },
    "report": {
        "agentBalance": "Agent Balance",
        "agentComm": "Agent Comm",
        "agentPl": "Agent P/L",
        "agentStaked": "Agent Staked",
        "commTurnover": "Comm Turnover",
        "customer": "Customer",
        "customerBalance": "Customer Balance",
        "customerYield": "Customer Yield",
        "totalAgent": "Total Agent"
    },
    "bookmaker": {
        "active": "ACTIVE",
        "betting": "Betting",
        "bettingError": "Betting Error",
        "code": "Code",
        "confirmActivate": "Are you sure you want to activate {name} bookmaker?",
        "confirmDeactivate": "Are you sure you want to deactivate {name} bookmaker?",
        "confirmRunBetting": "Are you sure you want to add {name} to feeds and run {name} betting?",
        "confirmStopBetting": "Are you sure you want to exclude {name} from feeds and stop {name} betting?",
        "confirmStopBettingAll": "Are you sure you want to stop betting for ALL bookmakers?",
        "maintenance": "Maintenance",
        "name": "Name",
        "run": "Run",
        "stop": "Stop",
        "stopBettingAll": "STOP BETTING",
        "title": "Bookmakers",
        "url": "Url",
        "params": {
            "columns": {
                "param": "Param",
                "value": "Value"
            },
            "alreadyExists": "Param with this name already exists for this site.",
            "paramRequired": "Param is required.",
            "paramMaxLength": "Param may not be greater than {max} characters.",
            "valueRequired": "Value is required.",
            "valueMaxLength": "Value may not be greater than {max} characters.",
            "confirmDelete": "Delete this param?",
            "editHint": "Double-click to edit",
            "editHintMobile": "Tap to edit",
            "form": {
                "createTitle": "New param"
            },
            "loadError": "Unable to load params.",
            "noData": "No params."
        }
    },
    "bots": {
        "columns": {
            "balance": "Balance",
            "bets": "Bets",
            "created": "Created",
            "id": "ID",
            "lastActivity": "Last activity",
            "market": "M",
            "name": "Bot",
            "status": "Status",
            "turnover": "Turnover",
            "user": "User"
        },
        "detailsTitle": "Bot Details",
        "info": {
            "marginTo": "to {value}%",
            "minStake": "Min"
        },
        "filters": {
            "botId": "Bot ID",
            "market": "Market",
            "name": "Name",
            "status": "Status",
            "statusActive": "Active",
            "statusInactive": "Inactive"
        },
        "status": {
            "active": "Active",
            "inactive": "Inactive"
        }
    },
    "common": {
        "1X2": "1X2",
        "actions": "Actions",
        "details": "Details",
        "markets": "Markets",
        "referenceIds": "Reference IDs",
        "allBookmakers": "All Bookmakers",
        "allBots": "All Bots",
        "allItems": "All Items",
        "alreadyExistLeague": "Unable to Add. League with this name already attached",
        "alreadyExists": "Unable to {operation} this {table}. {table} with this {uniqColumnNames} already exists",
        "asianHandicap": "Asian Handicap",
        "away": "Away",
        "betSource": "Bet Source",
        "betStatus": "Bet Status",
        "betType": "Bet Type",
        "bookmakers": "Bookmaker | Bookmakers",
        "boolean": "The {attribute} field must be true or false",
        "bots": "Bot | Bots",
        "bts": "BTS",
        "btsAbbr": "BTS",
        "btts": "Both Teams To Score",
        "clearHistory": "Clear history",
        "copiedToClipboard": "Copied to clipboard",
        "cornersAsianHandicap": "Corners Asian Handicap",
        "cornersAway": "Corners Away",
        "cornersGoal": "Corners Over/Under",
        "cornersGoalAbbr": "C-O/U",
        "cornersHandicapAbbr": "C-A/H",
        "cornersHome": "Corners Home",
        "cornersOver": "Corners Over",
        "cornersUnder": "Corners Under",
        "correctScore": "Correct Score",
        "csAbbr": "CS",
        "date": "Date",
        "dc": "DC",
        "dcAbbr": "DC",
        "deletedCountNotSuccess": "{countSuccess} record(s) has been successfully deleted. {countNotSuccess} record(s) was not removed",
        "deletedCountSuccess": "{countSuccess} record(s) has been successfully deleted",
        "displayedCurrency": "Display Currency",
        "doubleChance": "Double Chance",
        "draw": "Draw",
        "error": "An error occurred. Please try again later",
        "errorDeleted": "Record was not removed",
        "eventDate": "Game Date",
        "eventId": "Event ID",
        "eventType": "Event Type",
        "exists": "The selected {attribute} is invalid",
        "favorite": "Favorite",
        "filters": "Filters",
        "goal": "Over/Under",
        "goalAbbr": "O/U",
        "handicap": "Asian Handicap",
        "handicapAbbr": "A/H",
        "hiddenFilters": "Filters",
        "home": "Home",
        "in": "The selected {attribute} is invalid",
        "integer": "The {attribute} must be an integer",
        "imagePath": "Image Name",
        "item": "Item | Items",
        "json": "The {attribute} must be a valid JSON string",
        "kickOff": "Kick Off",
        "live": "Live",
        "loading": "Loading...",
        "maintenance": "This website is currently undergoing scheduled maintenance. We should be back shortly.",
        "market": "Market",
        "marketType": "Market Type (PG/LV)",
        "market1H": "First Half",
        "marketDball": "Pregame",
        "marketDballShort": "PG",
        "marketFT": "Full Time",
        "marketLive": "Live",
        "marketLiveShort": "LV",
        "max": {
            "array": "The {attribute} may not have more than {max} items",
            "file": "The {attribute} may not be greater than {max} kilobytes",
            "numeric": "The {attribute} may not be greater than {max}",
            "string": "The {attribute} may not be greater than {max} characters"
        },
        "min": {
            "array": "The {attribute} must have at least {min} items",
            "file": "The {attribute} must be at least {min} kilobytes",
            "numeric": "The {attribute} must be at least {min}",
            "string": "The {attribute} must be at least {min} characters"
        },
        "minThreeChars": "Type at least 3 characters",
        "month": "Month",
        "no": "No",
        "noBookmakers": "Bookmaker",
        "noBots": "Bot",
        "noDataAvailable": "No data available",
        "noHiddenFilters": "No hidden filters",
        "noItem": "No Items",
        "noSettings": "No settings available",
        "notExistLeague": "Unable to Remove. League with this name is not attached",
        "notFound": "Not found",
        "notIn": "The selected {attribute} is invalid",
        "notPermitted": "Operation is not permitted",
        "numeric": "The {attribute} must be a number",
        "of": "of",
        "operationForbidden": "There are no permission to access this action",
        "or": " or ",
        "order": "Order",
        "over": "Over",
        "period1H": "First Half",
        "period1HAbbr": "1H",
        "periodFT": "Full Time",
        "periodFTAbbr": "FT",
        "playerCurrency": "Player Currency",
        "pregame": "Pregame",
        "recent": "Recent",
        "regex": "The {attribute} format is invalid",
        "required": "The {attribute} field is required",
        "requiredIf": "The {attribute} field is required when {other} is {value}",
        "requiredWith": "The {attribute} field is required when {values} is present",
        "search": "Search",
        "selectAll": "Select All",
        "show": "Show",
        "showing": "Showing",
        "stake": "Stake",
        "string": "The {attribute} must be a string",
        "successAdded": "Record has been successfully added",
        "successDeleted": "Record has been successfully removed",
        "successSent": "Email sent successfully",
        "successUpdated": "Record has been successfully updated",
        "team": "Team",
        "customTeam": "Custom Team",
        "customLeague": "Custom League",
        "today": "Today",
        "total": "Total",
        "tradingType": "Trading Type",
        "under": "Under",
        "underdog": "Underdog",
        "uniq": "The {attribute} already exists",
        "uploadFailed": "Something went wrong, please contact support",
        "week": "Week",
        "wrongParams": "Wrong request params.",
        "yes": "Yes"
    },
    "customLeagues": {
        "actions": {
            "delete": "Delete custom league",
            "edit": "Edit custom league"
        },
        "age": "Age",
        "category": "Category",
        "confirmDelete": "Delete this custom league?",
        "country": "Country",
        "fixing": "Fixing",
        "form": {
            "ageCategory": "Age category",
            "category": "Category",
            "country": "Country",
            "createTitle": "Add custom league",
            "editTitle": "Edit custom league",
            "fixing": "Fixing",
            "gender": "Gender",
            "limitsCategory": "Limits category",
            "marketCategory": "Market category",
            "minute": "Minute",
            "name": "Name",
            "rank": "Rank",
            "save": "Save",
            "tier": "Tier",
            "wikiLink": "Wiki link"
        },
        "gender": "Gender",
        "limits": "Limits",
        "market": "Market",
        "minute": "Minute",
        "name": "Name",
        "sport": "Sport",
        "tier": "TIER",
        "wiki": "Wiki"
    },
    "customTeam": {
        "actions": {
            "delete": "Delete custom team",
            "edit": "Edit custom team"
        },
        "confirmDelete": "Delete this custom team?",
        "countryName": "Country",
        "createdAt": "Created",
        "deletedAt": "Deleted",
        "fileUploadError": "The file failed to upload.",
        "filters": {
            "countryId": "Country",
            "customTeamIsWomen": "Women",
            "customTeamIsYouth": "Youth",
            "customTeamName": "Custom Team Name",
            "customTeamTypeId": "Type",
            "sportId": "Sport"
        },
        "form": {
            "country": "Country",
            "createTitle": "Add custom team",
            "editTitle": "Edit custom team",
            "name": "Name",
            "save": "Save",
            "twitter": "Twitter",
            "type": "Type",
            "wikiLink": "Wiki link",
            "women": "Women",
            "youth": "Youth"
        },
        "gameCount": "Game Count",
        "id": "ID",
        "image": "Image",
        "imageEditHint": "Double-click to edit",
        "imageEditHintMobile": "Tap to edit",
        "imagePath": "The Image Name must end with one of the following: .png, .webp.",
        "imagePathNoExists": "Image file does not exist",
        "isImageChangedManually": "Manual Image",
        "isUseTradeball": "Tradeball",
        "logo": "Logo",
        "logoUploadFailed": "File upload failed",
        "logoUploaded": "File uploaded successfully",
        "logoWebpConversionFailed": "Logo uploaded, but WebP conversion failed",
        "name": "Name",
        "shortCode": "Short Code",
        "sportId": "Sport",
        "twitter": "Twitter",
        "typeId": "Type",
        "updatedAt": "Updated",
        "uploadLogo": {
            "browse": "Browse Files",
            "divider": "or",
            "dropTitle": "Drag and drop PNG here",
            "title": "Upload Logo",
            "upload": "Upload"
        },
        "wikiLink": "Wiki",
        "women": "Women",
        "youth": "Youth"
    },
    "eventExtra": {
        "error": "Failed to load event extra",
        "title": "Event Extra"
    },
    "dark": {
        "off": "Dark Mode Off",
        "on": "Dark Mode On"
    },
    "dictionaries": {
        "15s": "15 sec",
        "1X2": "1X2",
        "1min": "1 min",
        "30s": "30 sec",
        "5min": "5 mins",
        "5s": "5 sec",
        "BTTS": "Both Teams To Score",
        "active": "Active",
        "allLines": "All Lines",
        "awayTeam": "Away Team",
        "betFailPlainError": {
            "bookmakerError": "Bookmaker error",
            "bookmakerFailedToExecute": "The bookmaker failed to execute the bet",
            "creditLineError": "Credit line error",
            "handicapChanged": "Handicap changed",
            "insufficientCredit": "Insufficient Credit",
            "oddsReduced": "Odds reduced"
        },
        "betResult": {
            "hl": "HL",
            "hw": "HW",
            "l": "L",
            "p": "P",
            "w": "W"
        },
        "betResultFull": {
            "hl": "Half Loss",
            "hw": "Half Win",
            "l": "Loss",
            "p": "Push",
            "w": "Win"
        },
        "betSelection": {
            "btsNo": "No",
            "btsYes": "Yes",
            "cornersGoalOver": "Over",
            "cornersGoalUnder": "Under",
            "cornersHandicapAway": "Away",
            "cornersHandicapHome": "Home",
            "cs": "",
            "dc12": "Home or Away",
            "dc1X": "Home or Draw",
            "dcX2": "Draw or Away",
            "drawNoBetAway": "Away",
            "drawNoBetHome": "Home",
            "goalAwayOver": "Over",
            "goalAwayUnder": "Under",
            "goalHomeOver": "Over",
            "goalHomeUnder": "Under",
            "goalOver": "Over",
            "goalUnder": "Under",
            "handicapAway": "Away",
            "handicapHome": "Home",
            "moneylineAway": "Away",
            "moneylineHome": "Home",
            "oneXTwoAway": "Away",
            "oneXTwoDraw": "Draw",
            "oneXTwoHome": "Home",
            "spreadAway": "Away",
            "spreadHome": "Home"
        },
        "betSelectionType": {
            "1X2": "1X2",
            "goal": "Over/Under",
            "handicap": "Asian Handicap"
        },
        "betStatus": {
            "abnormal": "Abnormal Void",
            "refunded": "Refunded",
            "rejected": "Rejected",
            "running": "Running",
            "settled": "Settled",
            "void": "Void",
            "waiting": "Waiting"
        },
        "bettingStatus": {
            "open": "Open",
            "settled": "Settled"
        },
        "bot": "Bot Bets",
        "botBetRepetition": {
            "oneBetPerEvent": "Only one bet per game",
            "oneBetPerEventScore": "Only one bet per game and score"
        },
        "botFavoriteSide": {
            "away": "Away",
            "home": "Home"
        },
        "botScoreSumCondition": {
            "equalTo": "Equal to",
            "greaterThan": "Greater than",
            "lessThan": "Less than"
        },
        "botTeamSelection": {
            "away": "Away",
            "favourite": "Favourite",
            "home": "Home",
            "underdog": "Underdog"
        },
        "clAgeCategory": {
            "kids": "Kids (U17 or younger)",
            "senior": "Senior (First team)",
            "youth": "Youth (U18 to U23)"
        },
        "clCategory": {
            "clubFriendly": "Club Friendly",
            "clubInternational": "Club International",
            "domesticCup": "Domestic Cup",
            "domesticLeague": "Domestic League",
            "international": "International",
            "internationalFriendly": "International Friendly"
        },
        "clLimits": {
            "high": "High",
            "low": "Low",
            "medium": "Medium",
            "micro": "Micro",
            "pro": "Pro"
        },
        "clMarketCategory": {
            "cfriEff": "CfriEff",
            "fanEff": "FanEff",
            "intEff": "IntEff",
            "kidEff": "KidEff",
            "lowEff": "LowEff",
            "medEff": "MedEff",
            "microEff": "MicroEff",
            "proEff": "ProEff",
            "youthEff": "YouthEff"
        },
        "closeReasonGameAccountBlocked": "Closed",
        "closeReasonGameFinished": "Game Finished",
        "closeReasonGameRejectedBet": "Rejected",
        "closeReasonGameStarted": "Game Started",
        "closeReasonInsufficientCredit": "Insufficient Credit",
        "closeReasonManuallyClosed": "Manually Closed",
        "closeReasonNormally": "Executed",
        "closeReasonScoreChanged": "Score Changed",
        "closeReasonTimedOut": "Timed Out",
        "closed": "Closed",
        "closing": "Closing",
        "correctScore": "Correct Score",
        "currency": {
            "brl": "BRL",
            "euro": "EUR",
            "gbp": "GBP",
            "hongKongDollar": "HKD",
            "malaysianRinggit": "MYR",
            "usd": "USD",
            "yen": "JPY"
        },
        "deviceType": {
            "mobile": "Mobile",
            "pc": "PC"
        },
        "documentType": {
            "id": "ID",
            "utility": "Utility"
        },
        "doubleChance": "Double Chance",
        "early": "Early",
        "earlyMarket": "Early Market",
        "english": "English",
        "equalTo": "Equal to",
        "eventPeriod": {
            "period1H": "First Half",
            "period1HShort": "1H",
            "periodFT": "Full Time",
            "periodFTShort": "FT"
        },
        "eventRedCards": {
            "away1ManUp": "Away 1 man up",
            "away2MenUp": "Away 2 men up",
            "bothTeamsDownTo10Men": "Both teams down to 10 men",
            "home1ManUp": "Home 1 man up",
            "home2MenUp": "Home 2 men up",
            "noRedCards": "No Red Cards"
        },
        "eventSituation": {
            "awayLeading": "Away leading",
            "awayLeadingBy1": "Away leading by 1",
            "awayLeadingBy2": "Away leading by 2",
            "awayLeadingBy3OrMore": "Away leading by 3 or more",
            "draw": "Draw",
            "favouriteLeading": "Favourite leading",
            "favouriteLeadingBy1": "Favourite leading by 1",
            "favouriteLeadingBy2": "Favourite leading by 2",
            "favouriteLeadingBy3OrMore": "Favourite leading by 3 or more",
            "homeLeading": "Home leading",
            "homeLeadingBy1": "Home leading by 1",
            "homeLeadingBy2": "Home leading by 2",
            "homeLeadingBy3OrMore": "Home leading by 3 or more",
            "noDraw": "No Draw",
            "underdogLeading": "Underdog leading",
            "underdogLeadingBy1": "Underdog leading by 1",
            "underdogLeadingBy2": "Underdog leading by 2",
            "underdogLeadingBy3OrMore": "Underdog leading by 3 or more"
        },
        "eventType": {
            "live": "Live",
            "pregame": "Pregame"
        },
        "feedLine": {
            "all": "All Lines",
            "five": "Five Lines",
            "four": "Four Lines",
            "main": "Main Line",
            "three": "Three Lines",
            "two": "Two Line"
        },
        "fiveLines": "Five Lines",
        "fourLines": "Four Lines",
        "gameStatus": {
            "next1h": "Next 1h",
            "next2h": "Next 2h",
            "next4h": "Next 4h",
            "notStarted": "Not Started",
            "todayGames": "Today Games"
        },
        "gender": {
            "men": "Men",
            "women": "Women"
        },
        "goal": "Over/Under",
        "greaterThan": "Greater than",
        "handicap": "Asian Handicap",
        "homeTeam": "Home Team",
        "inactive": "Inactive",
        "jollywhere": {
            "away": "Away",
            "home": "Home"
        },
        "lessThan": "Less than",
        "mainLine": "Main Line",
        "mappingProblemSolutionStatus": {
            "applied": "Applied",
            "proposed": "Proposed"
        },
        "mappingProblemStatus": {
            "awaitingData": "Awaiting Data",
            "open": "Open",
            "processing": "Processing",
            "resolvedAutomatic": "Resolved (Automatic)",
            "resolvedManual": "Resolved (Manual)",
            "resolvedThirdParty": "Resolved (Third Party)"
        },
        "mappingProblemType": {
            "leagueMismatch": "League Mismatch",
            "sameTeamOnBothSides": "Same Team On Both Sides",
            "teamOpponentMismatch": "Team Opponent Mismatch",
            "teamsSwapped": "Teams Swapped"
        },
        "marketType": {
            "full": {
                "bts": "Both Teams To Score",
                "cornersGoal": "Corners Total",
                "cornersHandicap": "Corners Asian Handicap",
                "cs": "Correct Score",
                "dc": "Double Chance",
                "drawNoBet": "Draw No Bet",
                "goal": "Goals Total",
                "goalAway": "Goals Away",
                "goalHome": "Goals Home",
                "handicap": "Asian Handicap",
                "moneyline": "Moneyline",
                "oneXTwo": "1X2",
                "spread": "Spread"
            },
            "short": {
                "bts": "BTS",
                "cornersGoal": "C-O/U",
                "cornersHandicap": "C-A/H",
                "cs": "CS",
                "dc": "DC",
                "drawNoBet": "DNB",
                "goal": "O/U",
                "goalAway": "A-O/U",
                "goalHome": "H-O/U",
                "handicap": "A/H",
                "moneyline": "ML",
                "oneXTwo": "1X2",
                "spread": "Spread"
            }
        },
        "men": "Men",
        "off": "OFF",
        "open": "Open",
        "order": "Order Bets",
        "orderOddsType": {
            "bestOdds": "Best Odds",
            "lowestOdds": "Lowest Odds",
            "medianOdds": "Median Odds"
        },
        "period1H": "First Half",
        "periodFT": "Full Time",
        "platform": {
            "apostasbf": "Apostas BF",
            "apostasnow": "Apostasnow",
            "betbox": "Betbox",
            "betbra": "Betbra",
            "bolsadeaposta": "Bolsa de Aposta",
            "drinbet": "Drinbet",
            "fulltbet": "Fulltbet",
            "greenwin": "Greenwin",
            "matchbook": "Matchbook",
            "oddrs": "Oddrs",
            "oddjusta": "Oddjusta",
            "tradeball": "Tradeball",
            "verdinhabet": "VerdinhaBet"
        },
        "portuguese": "Portuguese",
        "senior": "Senior",
        "sport": {
            "basketball": "Basketball",
            "football": "Football"
        },
        "teamAge": {
            "senior": "Senior",
            "youth": "Youth"
        },
        "teamType": {
            "club": "Club",
            "fantasy": "Fantasy",
            "national": "National"
        },
        "threeLines": "Three Lines",
        "timeAutoRefresh": {
            "15s": "15 sec",
            "1min": "1 min",
            "30s": "30 sec",
            "5min": "5 mins",
            "5s": "5 sec",
            "off": "OFF"
        },
        "today": "Today",
        "todayMarket": "Today Market",
        "toolUserType": {
            "administrator": "Administrator",
            "agent": "Agent",
            "agentView": "Agent-view",
            "agentPlatform": "Agent-platform",
            "company": "Company",
            "player": "Player",
            "root": "Root"
        },
        "tradingType": {
            "betOrder": "Order Bets",
            "bot": "Bot Bets"
        },
        "twoLines": "Two Lines",
        "transferOperation": {
            "deposit": "Deposit",
            "withdrawal": "Withdrawal"
        },
        "auditAction": {
            "add": "Add",
            "delete": "Delete",
            "update": "Update"
        },
        "transferStatus": {
            "approved": "Approved",
            "expired": "Expired",
            "pending": "Pending",
            "rejected": "Rejected"
        },
        "wlTransactionOperation": {
            "credit": "Credit",
            "debit": "Debit",
            "info": "Info"
        },
        "wlTransactionStatus": {
            "failed": "Failed",
            "manualClosed": "Manual closed",
            "notProcessed": "Not processed",
            "processed": "Processed"
        },
        "wlTransactionType": {
            "acceptBet": "Accept bet",
            "changeStatus": "Change status",
            "failedBet": "Failed bet",
            "newBet": "New bet",
            "unsetBet": "Unset bet"
        },
        "betSettlementType": {
            "new": "New",
            "update": "Update"
        },
        "women": "Women",
        "youth": "Youth"
    },
    "entityDbRow": {
        "error": "Failed to load DB row",
        "menuItem": "Get DB Row",
        "title": "DB Row"
    },
    "feedCustomEventExclude": {
        "successAdded": "Custom event excluded from all bookmakers successfully",
        "successDeleted": "Custom event included in all bookmakers successfully"
    },
    "feedEventExclude": {
        "successAdded": "Event excluded from feeds successfully",
        "successDeleted": "Event included in feeds successfully"
    },
    "filters": {
        "handicap": "Handicap",
        "handicapShort": "HDP"
    },
    "forgotPassword": {
        "email": "E-mail or Login",
        "sendPasswordResetLink": "Send Password Reset Link"
    },
    "leagues": {
        "actions": {
            "delete": "Delete league"
        },
        "association": {
            "associate": "Associate",
            "bookmakerLeague": "Bookmaker league",
            "title": "Associate custom league"
        },
        "associationStatus": "All leagues",
        "associationStatusAll": "All leagues",
        "associationStatusAssociated": "Only with association",
        "associationStatusNotAssociated": "Only without association",
        "bookmaker": "All Bookmakers",
        "bookmakerId": "Bookmaker ID",
        "confirmDelete": "Delete this league?",
        "customLeague": "Custom League",
        "customLeagueNameId": "CustomLeague Name (id)",
        "gameCount": "#Games",
        "name": "Name",
        "notAssociated": "Not associated",
        "sport": "Sport"
    },
    "live": {
        "stats": {
            "attacks": "Attacks",
            "attacksShort": "A",
            "corners": "Corners",
            "cornersShort": "C",
            "dangerousAttacks": "Dangerous Attacks",
            "dangerousAttacksShort": "DA",
            "fouls": "Fouls",
            "foulsShort": "F",
            "hitWoodwork": "Hit Woodwork",
            "hitWoodworkShort": "HW",
            "possession": "Possession %",
            "possessionShort": "P",
            "redCards": "Red Cards",
            "redCardsShort": "R",
            "shots": "Shots",
            "shotsOnTarget": "Shots on Target",
            "shotsOnTargetShort": "ST",
            "shotsShort": "S",
            "yellowCards": "Yellow Cards",
            "yellowCardsShort": "Y"
        },
        "timeScore": "Time"
    },
    "loggedPlayers": {
        "appId": "App ID",
        "betPopups": "Bet Popups",
        "browser": "Browser",
        "bulk": {
            "confirmLogout": "Logout {count} selected player(s)?",
            "confirmReloadMain": "Go to main page and reload for {count} selected player(s)?",
            "confirmReloadTool": "Reload tool for {count} selected player(s)?",
            "logout": "Logout User",
            "reloadMain": "Go to main page + Reload",
            "reloadTool": "Reload Tool"
        },
        "connectionId": "ID",
        "expanded": {
            "bettingPopup": {
                "betSelectionId": "Bet selection",
                "correctScore": "Correct score",
                "customEventId": "Custom event",
                "handicap": "Handicap",
                "isLive": "Is live",
                "jollywhere": "Jollywhere",
                "marketId": "Market",
                "periodTypeId": "Period type",
                "popupKey": "Key",
                "score": "Score",
                "siteIds": "Sites",
                "uuid": "UUID"
            },
            "bettingPopupTitle": "Betting popup data",
            "eventPopup": {
                "customEventId": "Custom event",
                "eventDate": "Event date",
                "tradingTypeId": "Trading type"
            },
            "eventPopupTitle": "Event popup data",
            "markets": {
                "feedUniqData": "Feed uniq data",
                "feedVersion": "Feed version",
                "feedVersionPrev": "Feed version prev",
                "filterCustomEventIds": "Filter custom events",
                "filterLine": "Filter line",
                "filterMarketId": "Filter market",
                "filterPeriodTypeId": "Filter period type",
                "filterTradingTypeId": "Filter trading type",
                "marketKey": "Key"
            },
            "marketsTitle": "Markets"
        },
        "favEvents": "Fav events",
        "favoriteCustomEventIdsError": "Failed to load favorite custom event ids",
        "favoriteCustomEventIdsTitle": "Fav Custom Event Ids",
        "infoMenu": {
            "favoriteCustomEventIds": "Fav Custom Event Ids",
            "rowData": "Show row data"
        },
        "ip": "IP",
        "os": "OS",
        "pageCode": "Page code",
        "pageUrl": "Page url",
        "rowDataError": "Failed to load row data",
        "rowDataTitle": "Row data",
        "scriptVersion": "Script Version",
        "search": "Search",
        "sessionStartedAt": "Session started at",
        "stats": {
            "totalUsers": "Total users"
        },
        "title": "Logged Players",
        "updatedAt": "Updated at",
        "userName": "User name"
    },
    "loggedAgentsAdmins": {
        "appId": "App ID",
        "browser": "Browser",
        "bulk": {
            "confirmLogout": "Logout {count} selected user(s)?",
            "confirmReloadTool": "Reload tool for {count} selected user(s)?",
            "logout": "Logout User",
            "reloadTool": "Reload Tool"
        },
        "connectionId": "ID",
        "ip": "IP",
        "os": "OS",
        "pageUrl": "Actual url",
        "role": "Role",
        "search": "Search",
        "sessionStartedAt": "Session started at",
        "stats": {
            "totalUsers": "Total users"
        },
        "title": "Logged Agents/Admins",
        "updatedAt": "Updated at",
        "userName": "User name"
    },
    "login": {
        "forgotPassword": "Forgot Password",
        "inactive": "Your account is inactive, please contact <a style=\"color: #ef3b3a\" href=\"mailto:support@tradeball.com\">support@tradeball.com</a>.",
        "incorrect": "Login or password incorrect",
        "login": "Login",
        "notVerified": "Your account is not verified",
        "password": "Password",
        "registration": "Registration",
        "successful": "Login successful",
        "tokenInvalid": "Token invalid or doesn't exists",
        "username": "Username",
        "verifyEmail": "please verify your email address"
    },
    "mappingProblem": {
        "accept": "Accept",
        "awayTeam": "Away Team",
        "bookmaker": "Bookmaker",
        "canBeAutoFixed": "Can be auto-fixed",
        "collapse": "Collapse",
        "confirmAccept": "Are you sure you want to accept the solution \"{description}\"?",
        "createdDateFilter": "Created date",
        "customEventIds": "Custom Event IDs",
        "date": "Date",
        "description": "Description",
        "eventDate": "Event Date",
        "eventId": "Event ID",
        "eventIds": "Event IDs",
        "events": "Events",
        "expand": "Expand",
        "expandAll": "Expand all solutions",
        "homeTeam": "Home Team",
        "id": "ID",
        "league": "League",
        "noSolutions": "No solutions",
        "possibleSolutions": "Possible solutions",
        "problem": "Problem",
        "problemBookmaker": "Problem Bookmaker",
        "problemInfo": "Problem info",
        "resolvedAt": "Resolved At",
        "search": "Search",
        "solutionDescription": "Possible solution",
        "solutionStatus": "Solution Status",
        "status": "Status",
        "statusFilter": "Status",
        "title": "Mapping Problems",
        "type": "Type",
        "typeFilter": "Type"
    },
    "menu": {
        "account": "Account",
        "accounting": "Accounting",
        "accounts": "Accounts",
        "activity": "Activity",
        "admin": "Admin",
        "alerts": "Alerts",
        "alertsUserDocuments": "{count} user(s) waiting for approval",
        "appAlerts": "App Alerts",
        "bets": "Bets",
        "bookBalance": "Bookmaker Balance",
        "userBalance": "User Balances",
        "report": "Reports",
        "bookmaker": "Bookmakers",
        "bots": "Bots",
        "botUsageStats": "Usage Stats",
        "changePassword": "Change Password",
        "columnsTab": "Columns",
        "confirmPassword": "Confirm New Password",
        "currentPassword": "Current Password",
        "customLeagues": "Custom Leagues",
        "customTeam": "Custom Teams",
        "events": "Game",
        "filtersTab": "Filters",
        "generalSettings": "General",
        "hideAll": "Hide All",
        "language": "Language",
        "leagues": "Leagues",
        "leagueDailyCoverage": "Leagues Daily Coverage",
        "live": "Live",
        "loggedPlayers": "Logged Players",
        "loggedAgentsAdmins": "Logged Agents/Admins",
        "login": "Login",
        "logout": "Logout",
        "mappingProblem": "Mapping Problems",
        "monitoring": "Monitoring",
        "proxy": "Proxy",
        "noSpecificSettings": "No specific settings for this page",
        "orders": "Orders",
        "notifications": "Notifications",
        "audit": "Audit",
        "exchangeRate": "Exchange Rate",
        "pageVisitHistory": "Page Visit History",
        "pageSettings": "Page Settings",
        "password": "New Password",
        "pregame": "Pregame",
        "rememberFilters": "Remember Filters",
        "resetOrder": "Reset Order",
        "saveFiltersState": "Save Filters State",
        "searchPlaceholder": "Search menu...",
        "searchRecent": "Recent",
        "showAll": "Show All",
        "system": "System",
        "team": "Teams",
        "timeZone": "Time Zone",
        "toolUserDetails": "Users Details",
        "toolUserDocuments": "Users Documents",
        "toolUserDocumentsShort": "Users Doc…",
        "toolUsers": "Users",
        "transfer": "Deposits & Withdrawals",
        "turnover": "Turnover",
        "turnoverEvent": "Game",
        "turnoverSelection": "Bet Selection",
        "useButtonForFiltersApply": "Use Apply Filters Button",
        "visibleColumns": "Visible Columns",
        "visibleFilters": "Visible Filters",
        "wlBalance": "WL Balance",
        "customerPl": "Customer P/L",
        "wlTransaction": "WL Transactions",
        "betSettlement": "Bet Settlement"
    },
    "customerPl": {
        "avgBetVsClose": "AVG Bet Vs Close",
        "avgBetVsOpen": "AVG Bet Vs Open",
        "avgStake": "AVG Stake",
        "bookmaker": "Bookmaker",
        "customLeague": "Custom League",
        "customLeagues": "Custom Leagues",
        "datePeriod": {
            "days30": "30 Days",
            "days60": "60 Days",
            "days90": "90 Days",
            "days360": "360 Days",
            "lifetime": "Lifetime",
            "range": "Range Date",
            "title": "Period"
        },
        "lastBet": "Last Bet",
        "leagueLimits": "League Limits",
        "market": "Market",
        "marketType": "Market Type",
        "mobile": "Mobile",
        "name": "Name",
        "pc": "PC",
        "periodType": "Period Type",
        "roi": "ROI",
        "sport": "Sport",
        "totalBets": "#Total Bets",
        "totalPl": "Total P/L",
        "totalStake": "Total Stake",
        "user": "User"
    },
    "monitoring": {
        "accounts": "Accounts Allocation",
        "accountsSection": {
            "accounts": "Accounts",
            "allocated": "Allocated",
            "bookmaker": "Bookmaker",
            "disabled": "Disabled",
            "free": "Free",
            "loggedIn": "Logged in",
            "loggedOut": "Logged out",
            "message": "Message"
        },
        "betting": "Betting",
        "bettingSection": {
            "accBRL": "Acc R$",
            "accEUR": "Acc €",
            "accHKD": "Acc HK$",
            "accTotal": "Acc Total",
            "accounts": "Accounts",
            "activeCredit": "Active credit",
            "activeCreditBRL": "R$ Credit",
            "activeCreditEUR": "€ Credit",
            "activeCreditHKD": "HK$ Credit",
            "bookmaker": "Bookmaker",
            "groups": "Groups",
            "maxSharing": "Max sharing",
            "proxies": "Proxies",
            "proxyLocations": "Proxy locations",
            "total": "TOTAL"
        },
        "parsing": "Parsing",
        "parsingSection": {
            "accounts": "Accounts",
            "basketball": "Basketball",
            "early": "Early",
            "feed": "Feed",
            "football": "Football",
            "live": "Live",
            "proxies": "Proxies",
            "proxyLocations": "Proxy locations",
            "today": "Today"
        },
        "proxy": "Proxy",
        "proxySection": {
            "allocated": "Allocated",
            "free": "Free",
            "mostAllocated": "Most allocated",
            "proxies": "Proxies",
            "proxyLocation": "Proxy location",
            "secondMostAllocated": "2nd most allocated",
            "thirdMostAllocated": "3rd most allocated"
        },
        "serverTime": "Server Time",
        "settlement": "Settlement",
        "settlementSection": {
            "account": "Account",
            "bookmaker": "Bookmaker",
            "game": "Game",
            "oldestUnsettledBets": "Oldest unsettled bets",
            "unsettledBets": "Unsettled bets"
        },
        "title": "Monitoring"
    },
    "orders": {
        "any": "Any",
        "attempting": "Attempting",
        "attemptingTopUp": "Attempting top up",
        "available": "Available",
        "betType": "Bet Type",
        "betsDone": "{count} bets done",
        "bookmaker": "Bookmaker",
        "closed": "Closed",
        "correctScore": "Correct Score",
        "date": "Date",
        "dateClose": "Date Close",
        "executed": "Executed",
        "executedTooltipBase": "Bet taken",
        "executedTooltipSuffix": "better odds",
        "failed": "Failed",
        "fillPercent": "Fill %",
        "gameAwayOver": "game Away Over",
        "gameAwayUnder": "game Away Under",
        "gameBtsNo": "game BTS No",
        "gameBtsYes": "game BTS Yes",
        "gameDrawOrAway": "game Draw or Away",
        "gameHomeOrAway": "game Home or Away",
        "gameHomeOrDraw": "game Home or Draw",
        "gameHomeOver": "game Home Over",
        "gameHomeUnder": "game Home Under",
        "gameOver": "game Over",
        "gameType": "Game Type",
        "gameUnder": "game Under",
        "id": "ID",
        "kickOff": "Kick Off",
        "koTime": "KO Time",
        "market": "Market",
        "noBets": "No bets",
        "oneBetDone": "One bet done",
        "open": "Open",
        "order": "Order",
        "orderDateFilter": "Order date",
        "orderId": "Order ID",
        "orderStake": "Order Stake",
        "outcome": "Outcome",
        "selected": "Selected",
        "status": "Status",
        "timeout": "Timeout",
        "title": "Orders",
        "user": "User"
    },
    "audit": {
        "action": "Action",
        "editedFields": "Edited fields",
        "id": "ID",
        "name": "Name",
        "objectId": "Object ID",
        "source": "Source",
        "table": "Type",
        "time": "Time",
        "user": "User"
    },
    "pageVisitHistory": {
        "agent": "Agent",
        "appId": "App ID",
        "date": "Date",
        "dateFilter": "Date",
        "dateFirst": "First",
        "dateLast": "Last",
        "get": "GET",
        "number": "#",
        "page": "Page",
        "post": "POST",
        "search": "Search",
        "source": "Source",
        "uniqAppId": "Uniq App Id",
        "url": "Url",
        "user": "User"
    },
    "perfLogger": {
        "activeKey": "Active key",
        "clear": "Clear",
        "clearAll": "Clear all statistics",
        "colCount": "Samples",
        "colKey": "Key",
        "colLoad": "Load min / max / avg (ms, per item)",
        "colRender": "Render min / max / avg (ms, per item)",
        "colTotal": "Total min / max / avg (ms, per item)",
        "colUndoLast": "Undo last",
        "keyHint": "Press OK or Enter. Empty key stops recording. Reloads are grouped under the active key.",
        "keyLabel": "Statistics key",
        "noData": "No samples yet",
        "sourceApp": "In-app reload",
        "sourceAppShort": "App",
        "sourcePage": "Page entry (mount)",
        "sourcePageShort": "Page",
        "title": "Performance logger",
        "togglePanel": "Performance logger",
        "undoLastApp": "Remove last in-app reload sample",
        "undoLastPage": "Remove last page entry sample"
    },
    "pregame": {
        "asianHandicap": "Asian Handicap",
        "away": "Away",
        "bookmaker": "Bookmaker",
        "btsPrices": "BTS",
        "cornersAsianHandicap": "C-HDP",
        "cornersGoal": "C-Goal",
        "cornersGoalLine": "C-Goal",
        "cornersGoalPriceOver": "C-Over",
        "cornersGoalPriceUnder": "C-Under",
        "cornersHdpLine": "C-HDP",
        "cornersHdpPriceAway": "C-Away",
        "cornersHdpPriceHome": "C-Home",
        "date": "Date",
        "dcPrice": "Double Chance",
        "dnb": "DNB",
        "dnbAway": "DNB Away",
        "dnbHome": "DNB Home",
        "eventExcludedFromFeeds": "{bookmaker} event is excluded from feeds",
        "eventExcludedFromFeedsWithOthers": "{bookmaker}(+another bookies) event is excluded from feeds",
        "eventExcludedOnThirdPartyWebsite": "Event is excluded on a third-party website",
        "eventPeriodId": "Event Period",
        "eventStartPeriod": "Game Start Period",
        "excludeBookmakerAndOthersFromFeeds": "Exclude {bookmaker} (+another bookies) from feeds",
        "excludeBookmakerFromFeeds": "Exclude {bookmaker} from feeds",
        "excludeFromAllBookmakers": "Exclude event from all bookmakers",
        "excluded": "Excluded",
        "excludedFromAllBookmakers": "Excluded event from all bookmakers",
        "game": "Game",
        "gameDateFilter": "Game date",
        "gameStatus": {
            "finished": "Finished",
            "firstHalf": "First Half",
            "live": "Live",
            "secondHalf": "Second Half",
            "upcoming": "Upcoming"
        },
        "goal": "Goal",
        "goalAway": "Goals Away",
        "goalAwayLine": "Goals Away",
        "goalAwayPriceOver": "A-O/U Over",
        "goalAwayPriceUnder": "A-O/U Under",
        "goalHome": "Goals Home",
        "goalHomeLine": "Goals Home",
        "goalHomePriceOver": "H-O/U Over",
        "goalHomePriceUnder": "H-O/U Under",
        "goalLine": "Goal",
        "goalPriceOver": "Over",
        "goalPriceUnder": "Under",
        "hdpLine": "HDP",
        "hdpPriceAway": "Away",
        "hdpPriceHome": "Home",
        "home": "Home",
        "invert": "Invert",
        "invertConfirm": {
            "confirm": "Invert",
            "message": "Important! Game {game} will be inverted to {invertedGame} for ALL bookmakers"
        },
        "inverted": "Inverted",
        "isInverted": "Inverted",
        "league": "League",
        "leagueLimitsCategory": "League Limits Category",
        "line": "Line",
        "moneyline": "Moneyline",
        "oneXTwo": "1X2",
        "points": "Points",
        "pointsLine": "Points",
        "score": "Score",
        "showOpenPrices": "Open Prices",
        "spread": "Spread",
        "spreadLine": "SP",
        "spreadPriceAway": "Away",
        "spreadPriceHome": "Home"
    },
    "rules": {
        "between": "This field has to be between {min} and {max}",
        "correctScoreFormat": "Format must be X-Y (e.g., 2-1) Max score is 99-99",
        "email": "Invalid e-mail address",
        "emailDoesNotMatch": "E-mail does not match",
        "fileSize": "Size of file should be less than {size} MB",
        "grOrEqual": "{field} To has to be equal or more than {field} From",
        "greaterThanValue": "{field} has to be more than {value}",
        "integer": "This field has to be integer",
        "lsOrEqual": "{field} From has to be less or equal to {field} To",
        "max": "The maximum value for this field is {value}",
        "maxLength": "Maximum {max} characters",
        "min": "The minimum value for this field is {value}",
        "minLength": "Minimum {min} characters",
        "multipleOf": "The value has to be multiples of {value}",
        "negative": "This field cannot be negative",
        "newPasswordDoesNotMatch": "New password does not match",
        "number": "This field has to be number",
        "required": "Required"
    },
    "team": {
        "actions": {
            "delete": "Delete team"
        },
        "association": {
            "age": "Age",
            "associate": "Associate",
            "bookmakerTeam": "Bookmaker team",
            "genre": "Genre",
            "suggested": "Suggested",
            "title": "Associate custom team"
        },
        "associationStatus": {
            "all": "All teams",
            "allNoFantasy": "All teams - no fantasy",
            "associated": "With association",
            "fantasy": "Fantasy",
            "notAssociated": "Without association"
        },
        "bookmakerId": "Book",
        "confirmDelete": "Delete this team?",
        "createdAt": "Created",
        "customTeamId": "Custom Team Name (ID)",
        "filters": {
            "bookmakerId": "Bookmaker",
            "customTeamAssociationStatus": "Association",
            "customTeamId": "Custom Team",
            "sportId": "Sport",
            "teamName": "Team Name"
        },
        "gameCount": "Games",
        "id": "ID",
        "internalId": "Internal ID",
        "name": "Name",
        "notAssociated": "Not associated",
        "sportId": "Sport",
        "updatedAt": "Updated"
    },
    "toolUserDetails": {
        "actions": {
            "approvalSent": "Approval sent",
            "delete": "Delete",
            "sendApproval": "Send Approval"
        },
        "columns": {
            "agent": "Agent",
            "country": "Country",
            "currency": "Currency",
            "date": "Date",
            "documents": "Documents",
            "email": "Email",
            "idProof": "ID Proof",
            "login": "Username",
            "name": "Name",
            "refUser": "Ref user",
            "sendEmail": "Send Email",
            "surname": "Surname",
            "utilityProof": "Utility Proof",
            "validIdDoc": "Valid ID doc",
            "validUtilityDoc": "Valid Utility doc"
        },
        "confirmDelete": "Delete this user?",
        "confirmSendApproval": "Send approval notification to this user?",
        "documents": {
            "approve": "Please check!",
            "approved": "Approved",
            "waiting": "Waiting"
        },
        "filters": {
            "agent": "Agent",
            "country": "Country",
            "currency": "Currency",
            "documents": "Documents",
            "documentsApproved": "Approved",
            "documentsPleaseCheck": "Please check!",
            "documentsWaiting": "Waiting",
            "search": "Search",
            "status": "Status",
            "statusActive": "Active",
            "statusDeleted": "Deleted",
            "statusInactive": "Inactive"
        },
        "tooltips": {
            "column": {
                "idProof": "ID document approved",
                "sendEmail": "Send approval email",
                "utilityProof": "Utility document approved",
                "validIdDoc": "ID document is valid",
                "validUtilityDoc": "Utility document is valid"
            }
        }
    },
    "toolUserDocuments": {
        "actions": {
            "delete": "Delete",
            "getFile": "Get file"
        },
        "columns": {
            "date": "Date",
            "documentType": "Document type",
            "file": "File",
            "fileName": "File name",
            "username": "Username",
            "valid": "Valid"
        },
        "confirmDelete": "Delete this document?",
        "filters": {
            "documentType": "Document type",
            "search": "Search"
        },
        "tooltips": {
            "valid": "Toggle to mark the document as valid"
        },
        "type": {
            "id": "ID",
            "utility": "Utility"
        }
    },
    "toolUsers": {
        "actions": {
            "delete": "Delete",
            "send": "Send"
        },
        "activation": {
            "sent": "Sent"
        },
        "columns": {
            "act": "ACT",
            "actBots": "Act bots",
            "activation": "Activation",
            "balance": "Balance",
            "betBalance": "Bet Balance",
            "bets": "Bets",
            "bots": "Bots",
            "c": "C",
            "createdBy": "Created by",
            "credit": "Credit",
            "creditLimit": "Credit limit",
            "date": "Date",
            "documentsShort": "D",
            "exposure": "Exposure",
            "id": "ID",
            "lastBet": "Last bet",
            "lastLogin": "Last Login",
            "role": "Role",
            "sub": "Sub",
            "suspendedShort": "S",
            "suspiciousShort": "?",
            "transferBal": "Transfer Bal",
            "username": "Username",
            "verifyEmail": "Verify Email"
        },
        "confirmActivateUser": "Activate user {user}?",
        "confirmDeactivateUser": "Deactivate user {user}?",
        "confirmDelete": "Delete this user?",
        "positionRules": {
            "add": "Add position rule",
            "columns": {
                "active": "Active",
                "date": "Date"
            },
            "confirmDelete": "Delete this position rule?",
            "form": {
                "createTitle": "New position rule",
                "editTitle": "Edit position rule"
            },
            "noData": "No position rules.",
            "open": "Position user rules",
            "title": "Position user rules"
        },
        "params": {
            "columns": {
                "param": "Param",
                "value": "Value"
            },
            "alreadyExists": "Param with this name already exists for this user.",
            "paramRequired": "Param is required.",
            "paramMaxLength": "Param may not be greater than {max} characters.",
            "valueRequired": "Value is required.",
            "valueMaxLength": "Value may not be greater than {max} characters.",
            "confirmDelete": "Delete this param?",
            "editHint": "Double-click to edit",
            "editHintMobile": "Tap to edit",
            "form": {
                "createTitle": "New param"
            },
            "loadError": "Unable to load params.",
            "noData": "No params."
        },
        "confirmSuspendUser": "Suspend user {user}?",
        "confirmUnsuspendUser": "Remove suspension for {user}?",
        "documents": {
            "approved": "Documents approved",
            "review": "Please check documents"
        },
        "filters": {
            "botStatus": "Bot status",
            "botStatusActive": "Active bots",
            "botStatusInactive": "No active bots",
            "search": "Search",
            "userCurrencyId": "All currencies",
            "userId": "User ID",
            "userObserveId": "All users",
            "userOwnerId": "Created by",
            "userPlatformId": "All platforms",
            "userStatus": "Status",
            "userStatusActive": "Active",
            "userStatusDeleted": "Deleted",
            "userStatusInactive": "Inactive",
            "userStatusNotDeleted": "Not deleted",
            "userStatusSuspended": "Suspended",
            "userTypeId": "Role"
        },
        "form": {
            "active": "Active",
            "agent": "Agent",
            "approvePermission": "Approve id/utility permission",
            "commissionBot": "Bot COMM%",
            "commissionOrder": "Order COMM%",
            "country": "Country",
            "createTitle": "Create user",
            "creditLimit": "Credit Limit",
            "currency": "Currency",
            "editTitle": "Edit user",
            "email": "E-Mail",
            "firstName": "First Name",
            "irregular": "Irregular",
            "name": "Name",
            "notSelected": "Not Selected",
            "note": "Note",
            "openedBy": "Opened by",
            "password": "Password",
            "passwordKeepCurrent": "Leave blank to keep current",
            "platform": "Platform",
            "positionSectionTitle": "Position %",
            "positionSectionTitleWl": "Position WL %",
            "positionBotPerc": "Bot %",
            "positionOrderPerc": "Order %",
            "positionBotWlPerc": "Bot WL %",
            "positionOrderWlPerc": "Order WL %",
            "positionUserRule": "User rule",
            "companyPosition": "Company position",
            "agentPosition": "Agent position",
            "referralLink": "Referral Link",
            "save": "Save",
            "surname": "Surname",
            "type": "Type",
            "typePlaceholder": "Select user type",
            "username": "Username",
            "watch": "Watch"
        },
        "tooltips": {
            "activatedAt": "Activated at {date} by {by}",
            "activationSentAt": "Activation email sent at {date} by {by}",
            "agentReferral": "Agent referral URL: {ref} — click ID to copy",
            "column": {
                "act": "Active — toggle account active state",
                "actBots": "Active bots",
                "activation": "Activation — send / view activation email status",
                "balance": "Total balance",
                "betBalance": "Bet balance (open bets)",
                "bets": "Total placed bets",
                "bots": "Total bots",
                "c": "Currency",
                "credit": "Available credit",
                "documents": "Documents — click icon to open the documents list",
                "exposure": "Open exposure",
                "lastBet": "Time since last bet",
                "role": "User role",
                "sub": "Sub-users count",
                "suspended": "Suspended user (orange)",
                "suspicious": "Suspicious activity flag",
                "transferBal": "Transfer balance",
                "verifyEmail": "Email verification status"
            },
            "copyReferralLink": "Copy referral link",
            "createdByPlatform": "Platform: {platform}",
            "deactivatedAt": "Deactivated at {date} by {by}",
            "openUserDetails": "Click to open player details",
            "openUsersPage": "Click to open Users page",
            "verifyEmailSentAt": "Verify email sent at {date} by {by}"
        },
        "verify": {
            "verified": "Verified"
        }
    },
    "turnoverEvent": {
        "away": "Away",
        "bets": "Bets Count",
        "date": "Date",
        "gameDateFilter": "Game date",
        "gameGrid": {
            "bets": "Bets",
            "companyGrid": "Company PL",
            "gridMode": "Grid",
            "open": "Game Grid",
            "platform": "Platform",
            "playerGrid": "Player PL",
            "position": "Position",
            "stake": "Stake",
            "title": "Game Grid"
        },
        "home": "Home",
        "league": "League",
        "limitCategory": "Limits Category",
        "minute": "Minute",
        "notStarted": "Not Started",
        "pl": "User P/L",
        "playing": "Playing",
        "score": "Score",
        "settling": "Settling",
        "settled": "Settled",
        "stake": "User Stake",
        "status": "Status",
        "unsettledBets": "Unsettled Bets Count",
        "users": "Users Count"
    },
    "turnoverSelection": {
        "away": "Away",
        "bets": "Bets Count",
        "date": "Date",
        "gameDateFilter": "Game date",
        "handicap": "Handicap",
        "home": "Home",
        "league": "League",
        "limitCategory": "Limits Category",
        "netPayout": "Max Net Payout",
        "oddsAvg": "Average Odds",
        "period": "Market",
        "pl": "User P/L",
        "selection": "Selection",
        "stake": "User Stake",
        "unsettledBets": "Unsettled Bets Count",
        "users": "Users Count"
    },
    "user": {
        "passwordDoesNotMatchCurrent": "The given password does not match the current password",
        "passwordSuccessChanged": "Password was successfully changed",
        "passwordsDontMatch": "Passwords don't match",
        "playerEmailAlreadyExist": "A player with this email already exists",
        "timezoneSuccessChanged": "Timezone was successfully changed"
    },
    "virtualMarket": {
        "correctScore": "Score",
        "date": "Date",
        "handicap": "Handicap",
        "jollywhere": "Jollywhere",
        "line": "Line",
        "marketTypeLive": {
            "bts": "Live Both Teams To Score Virtual Market",
            "cornersGoal": "Live Corners Over/Under Virtual Market",
            "cornersHandicap": "Live Corners Asian Handicap Virtual Market",
            "cs": "Live Correct Score Virtual Market",
            "dc": "Live Double Chance Virtual Market",
            "drawNoBet": "Live Draw No Bet Virtual Market",
            "goal": "Live Over/Under Virtual Market",
            "goalAway": "Live Goals Away Virtual Market",
            "goalHome": "Live Goals Home Virtual Market",
            "handicap": "Live Handicap Virtual Market",
            "moneyline": "Live Moneyline Virtual Market",
            "oneXTwo": "Live 1X2 Virtual Market",
            "spread": "Live Spread Virtual Market"
        },
        "marketTypePregame": {
            "bts": "Pregame Both Teams To Score Virtual Market",
            "cornersGoal": "Pregame Corners Over/Under Virtual Market",
            "cornersHandicap": "Pregame Corners Asian Handicap Virtual Market",
            "cs": "Pregame Correct Score Virtual Market",
            "dc": "Pregame Double Chance Virtual Market",
            "drawNoBet": "Pregame Draw No Bet Virtual Market",
            "goal": "Pregame Over/Under Virtual Market",
            "goalAway": "Pregame Goals Away Virtual Market",
            "goalHome": "Pregame Goals Home Virtual Market",
            "handicap": "Pregame Handicap Virtual Market",
            "moneyline": "Pregame Moneyline Virtual Market",
            "oneXTwo": "Pregame 1X2 Virtual Market",
            "spread": "Pregame Spread Virtual Market"
        },
        "price": "Price",
        "score": "Score",
        "shortTitle": "VM",
        "stats": {
            "attacks": "Attacks",
            "corners": "Corners",
            "dangerousAttacks": "Dangerous Attacks",
            "fouls": "Fouls",
            "hitWoodwork": "Hit Woodwork",
            "possessionTime": "Possession Time",
            "red": "Red",
            "score": "Score",
            "shortTitle": "Live Stats",
            "shots": "Shots",
            "shotsOnTarget": "Shots on Target",
            "time": "Time",
            "title": "Live Stats Virtual Market",
            "yellow": "Yellow"
        },
        "teams": "Teams",
        "title": "Virtual Market History"
    },
    "wlBalance": {
        "a2fFinalOperation": "A2F Final Operation",
        "balanceAgentBrl": "Balance Agent BRL",
        "balanceAgentEuro": "Balance Agent EUR",
        "balanceBookmakerBrl": "Balance Bookmaker BRL",
        "balanceBookmakerEuro": "Balance Bookmaker EUR",
        "betCount": "#Bets",
        "bookFeesBrl": "Book Fees BRL",
        "bookFeesEuro": "Book Fees EUR",
        "bookRebateBrl": "Book Rebate BRL",
        "bookRebateEuro": "Book Rebate EUR",
        "companyComBrl": "Company Com BRL",
        "companyComEuro": "Company Com EUR",
        "platform": "Platform",
        "playerComBrl": "Player Com BRL",
        "playerComEuro": "Player Com EUR",
        "playerPl": "Player P/L",
        "playerStake": "Player Stake",
        "tbBookCommissionsEur": "TB Book Commissions EUR",
        "tbFinalOperationBrl": "TB Final Operation BRL",
        "tbFinalOperationEur": "TB Final Operation EUR",
        "tbToBookiesBrl": "TB to Bookmakers BRL",
        "tbToBookiesEur": "TB to Bookmakers EUR",
        "tooltips": {
            "a2fFinalOperation": "[WL to TB] minus [Player P/L]",
            "betCount": "Total number of bets",
            "tbBookCommissionsEur": "[Bookmakers Commissions] plus [Matchbook fee Rebate]",
            "tbFinalOperation": "[Bookmaker Balance] minus [Agent Balance] minus [Bookmakers Fees] minus [Agent Payable Commissions]",
            "tbToBookmakers": "[Bookmakers Balance] minus [Bookmakers Fees]. Negative values indicate payments to the bookmakers (including exchange fees).",
            "wlToTb": "[TB to Bookmaker] minus [TB Final Operation]"
        },
        "totalEuro": "TOTAL Euro(€)",
        "wlToTb": "WL to TB"
    },
    "wlTransaction": {
        "accept": "Accept",
        "amount": "Amount",
        "availableBalance": "Available Balance",
        "betInternalId": "Bet Internal ID",
        "canBeAutoFixed": "Can be auto-fixed",
        "collapse": "Collapse",
        "confirmAccept": "Are you sure you want to accept the solution \"{description}\"?",
        "createdAt": "Created",
        "description": "Description",
        "events": "Events",
        "expand": "Expand",
        "expandAll": "Expand all solutions",
        "id": "ID",
        "infoTooltip": "Additional information",
        "log": {
            "error": "Failed to load transaction log",
            "title": "Transaction Log"
        },
        "noSolutions": "No solutions",
        "operation": "Operation",
        "possibleSolutions": "Possible solutions",
        "problem": "Problem",
        "problemInfo": "Problem info",
        "processedAt": "Processed",
        "processingStartedAt": "Processing Started",
        "resolvedAt": "Resolved At",
        "search": "Transaction Search",
        "solutionDescription": "Possible solution",
        "solutionStatus": "Solution Status",
        "status": "Status",
        "statusFilter": "Status",
        "title": "WL Transactions",
        "transactionDateFilter": "Transaction date",
        "type": "Type",
        "typeFilter": "Type",
        "user": "User"
    },
    "betSettlement": {
        "account": "Account",
        "balance": "Balance",
        "betDate": "Bet date",
        "betId": "Bet ID",
        "bookBetId": "Book bet ID",
        "bookmaker": "Bookmaker",
        "bookmakerOdds": "Bookmaker Odds",
        "date": "Date",
        "dateFilter": "Date",
        "stake": "Stake",
        "stats": {
            "unsettledBets": "Unsettled bets"
        },
        "title": "Bet Settlement",
        "type": "Type",
        "validBalance": "Valid balance",
        "log": {
            "title": "View Settlement Log",
            "windowTitle": "Settlement Log"
        }
    },
    "leagueDailyCoverage": {
        "columns": {
            "betdaq": "Betdaq",
            "bf": "Betfair",
            "eventsCount": "Events",
            "isTradeballNetwork": "Tradeball Network",
            "matchbook": "Matchbook",
            "name": "Leagues",
            "pinna": "Pinnacle",
            "sportId": "Sport"
        },
        "filters": {
            "date": "Date"
        },
        "stats": {
            "totalLeagues": "Leagues"
        },
        "title": "Leagues Daily Coverage"
    },
    "window": {
        "closeAll": "Close all windows",
        "minimize": "Minimize",
        "minimizeAll": "Minimize all windows",
        "untitled": "Window"
    },
    "botUsageStats": {
        "columns": {
            "betCount": "# Bets",
            "betPerc": "% Bets",
            "botCount": "# Bots",
            "botCountActive": "# Active Bots",
            "botPerc": "% Bots",
            "botPercActive": "% Active Bots",
            "name": "Name"
        },
        "sections": {
            "betType": "Bet Type",
            "conditions": "Conditions",
            "options": "Other Options",
            "stakeType": "Stake Type"
        }
    }
}
